import classNames from 'classnames';
import React, { memo } from 'react';
import { LineItem } from '../../../../services/quote.interfaces';
import { asCurrencyString } from '../../../../utils/asCurrencyString/asCurrencyString.util';

interface QuoteCostBreakdownSectionContentItemProps {
  lineItem: LineItem;
}

const QuoteCostBreakdownSectionContentItem: React.FC<
  QuoteCostBreakdownSectionContentItemProps
> = ({ lineItem }) => {
  const {
    name,
    amount,
    savingsNotice,
    discountName,
    discountedAmount,
    footnote,
  } = lineItem;
  const isDiscounted = discountName && discountedAmount;

  const isLegalFeeLineItem = () => name === 'Legal fee';

  return (
    <React.Fragment key={'name'}>
      <li
        className={classNames(
          'flex items-center justify-between text-text/body',
          {
            'text-text/body-disabled line-through': isDiscounted,
          }
        )}
      >
        <p>
          {name}
          {isLegalFeeLineItem() && <span>*</span>}
        </p>
        <p className="text-xl font-bold">{asCurrencyString(amount)}</p>
      </li>
      {isDiscounted && (
        <li
          className={classNames(
            'flex items-center justify-between text-text/body-support-success'
          )}
        >
          <p>{discountName}</p>
          <p className="text-xl font-bold">
            {asCurrencyString(discountedAmount)}
          </p>
        </li>
      )}
      {savingsNotice && (
        <div className="mt-4 relative bg-text/body-support-success w-full flex flex-col p-3 text-system/white text-left gap-y-3">
          <span className="absolute -top-3.5 right-3 bg-[url('/svgs/green-speech-point.svg')] w-6 h-5" />
          <p className="text-sm font-dm-sans">{savingsNotice}</p>
        </div>
      )}
    </React.Fragment>
  );
};

export default memo(QuoteCostBreakdownSectionContentItem);
